module.exports = __webpack_public_path__ + "img/sti-sc-active.222086cc.svg";